import { css, cx } from '@linaria/atomic';
import { NakedButton } from '../../../naked';
import type { CalendarWeekType } from '../calendar-types';
import { useCalendarState } from '../provider';
import type { BaseAtomProps } from './calendar-atom.types';

const weekRow = css`
  display: flex;
  justify-content: space-between;
`;

const dayClass = css`
  text-align: center;
`;

type CalendarWeekProps = BaseAtomProps & {
  days: CalendarWeekType;
};

export const CalendarWeek = ({ className, days, ...rest }: CalendarWeekProps) => {
  const { getDayButtonProps } = useCalendarState();
  return (
    <div className={cx('cal__week', weekRow, className)} {...rest}>
      {days.map((day, i) =>
        !day ? (
          <div className={cx('cal__day', 'cal__day--empty', dayClass)} key={i} />
        ) : (
          <NakedButton key={i} className={cx('cal__day', dayClass)} type='button' {...getDayButtonProps(day)}>
            {day.day}
          </NakedButton>
        )
      )}
    </div>
  );
};
